import React, { useState } from "react";
import Dialog from "../../../../../components/Dialog/Dialog";
import InputDateForm from "../../../../../components/Input/InputDateForm";
import { Button } from "../../../../../components/ui/Buttons";
import { withStyles } from "@material-ui/core";
import moment from "moment";

const filterDateDefault = {
  dataInicial: moment()
    .startOf("week")
    .format("YYYY-MM-DD"),
  dataFinal: moment()
    .endOf("week")
    .format("YYYY-MM-DD"),
  exportado: { label: "Exportado", value: true },
};


const FilterLotes = ({
  classes,
  open,
  handleClickAplicar,
  filter
}) => {
  const [filterInterno, setFilterInterno] = useState(filter);

  const handleChangeFilter = (value, field) => {
    setFilterInterno((prevState) => {
      return {
        ...prevState,
        [field]: value,
      };
    });
  };


  const handleClickRedefinirFiltross = () => {
    setFilterInterno(filterDateDefault)
  }

  return (
    <Dialog open={open} classes={{ paper: classes.dialogRoot }}>
      <div className={classes.header}>
        <div className={classes.title}>Filtrar</div>
        <span
          id="pac-flo-btn-red"
          className={classes.spanRedefinir}
          onClick={() => handleClickRedefinirFiltross()}
        >
          Redefinir filtros
        </span>
      </div>
      <div className={classes.wrapperFilter}>
        <div className={classes.contentInputs}>
          <span className={classes.span}>Data inicial:</span>
          <InputDateForm
            id="pac-flo-inp-ini"
            adornmentPosition={"end"}
            onChange={(e) => handleChangeFilter(e, "dataInicial")}
            value={filterInterno.dataInicial}
          />
        </div>
        <div className={classes.contentInputs}>
          <span className={classes.span}>Data Final:</span>
          <InputDateForm
            id="pac-flo-inp-fin"
            adornmentPosition={"end"}
            value={filterInterno.dataFinal}
            onChange={(e) => handleChangeFilter(e, "dataFinal")}
          />
        </div>
      </div>

      <div className={classes.contentButton}>
        <Button id="pac-flo-btn-apl" width={"100%"} onClick={() => handleClickAplicar(filterInterno)}>
          Aplicar Filtro
        </Button>
      </div>
    </Dialog>
  );
};

const styles = {
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#505050",
  },
  title: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#505050",
  },
  dialogRoot: {
    display: "flex",
    minWidth: "550px",
    minHeight: "214px",
    borderRadius: "10px",
    flexDirection: "column",
    padding: "20px",
    justifyContent: "space-around",
  },
  span: {
    fontSize: "12px",
    color: "#868686",
  },
  contentButton: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  contentInputs: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
  wrapperFilter: {
    display: "flex",
    gap: "10px",
    width: "100%",
  },
  spanRedefinir: {
    fontSize: "12px",
    color: "#868686",
    cursor: "pointer",
  },
};
export default withStyles(styles)(FilterLotes);
